import { spacing } from "../spacing";
export var borderRadiuses = {
  /** spacing[1] (4px) */
  icon: spacing[1],
  /** spacing[2] (8px) */
  control: spacing[2],
  /** spacing[4] (16px) */
  container: spacing[4],
  /** 9999px */
  circle: '9999px'
};